'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Minus = function (_React$Component) {
	(0, _inherits3.default)(Minus, _React$Component);

	function Minus() {
		(0, _classCallCheck3.default)(this, Minus);
		return (0, _possibleConstructorReturn3.default)(this, (Minus.__proto__ || Object.getPrototypeOf(Minus)).apply(this, arguments));
	}

	(0, _createClass3.default)(Minus, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_base2.default,
				(0, _extends3.default)({ className: 'BurgerMinus' }, this.props),
				_react2.default.createElement(_style2.default, {
					styleId: '1752268168',
					css: '.BurgerMinus .BurgerInner:before,.BurgerMinus .BurgerInner:after{-webkit-transition:bottom 0.08s 0s ease-out, top 0.08s 0s ease-out, opacity 0s linear;transition:bottom 0.08s 0s ease-out, top 0.08s 0s ease-out, opacity 0s linear;}.BurgerMinus.BurgerActive .BurgerInner:before,.BurgerMinus.BurgerActive .BurgerInner:after{opacity:0;-webkit-transition:bottom 0.08s ease-out, top 0.08s ease-out, opacity 0s 0.08s linear;transition:bottom 0.08s ease-out, top 0.08s ease-out, opacity 0s 0.08s linear;}.BurgerMinus.BurgerActive .BurgerInner:before{top:0;}.BurgerMinus.BurgerActive .BurgerInner:after{bottom:0;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9taW51cy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTdUIsQUFNNkIsQUFJVCxBQU1KLEFBR0csTUFGVixHQUdBLENBUDRCLDBKQU43QixVQU9DIiwiZmlsZSI6Ii4uLy4uL3NyYy90eXBlcy9taW51cy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcblxuaW1wb3J0IEJhc2UgZnJvbSAnLi4vYmFzZSdcbmltcG9ydCBkZWZhdWx0UHJvcHMgZnJvbSAnLi4vZGVmYXVsdC1wcm9wcydcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgTWludXMgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnR7XG5cdHJlbmRlcigpIHtcblx0XHRyZXR1cm4gKFxuXHRcdFx0PEJhc2UgY2xhc3NOYW1lPSdCdXJnZXJNaW51cycgey4uLnRoaXMucHJvcHN9PlxuXHRcdFx0XHQ8c3R5bGUganN4IGdsb2JhbD57YFxuXHRcdFx0XHRcdC5CdXJnZXJNaW51cyB7XG5cdFx0XHRcdFx0XHQuQnVyZ2VySW5uZXIge1xuXHRcdFx0XHRcdFx0XHQmOmJlZm9yZSxcblx0XHRcdFx0XHRcdFx0JjphZnRlciB7XG5cdFx0XHRcdFx0XHRcdHRyYW5zaXRpb246IGJvdHRvbSAwLjA4cyAwcyBlYXNlLW91dCxcblx0XHRcdFx0XHRcdFx0XHRcdFx0XHR0b3AgMC4wOHMgMHMgZWFzZS1vdXQsXG5cdFx0XHRcdFx0XHRcdFx0XHRcdFx0b3BhY2l0eSAwcyBsaW5lYXI7XG5cdFx0XHRcdFx0XHRcdH1cblx0XHRcdFx0XHRcdH1cblxuXHRcdFx0XHRcdFx0Ji5CdXJnZXJBY3RpdmUge1xuXHRcdFx0XHRcdFx0XHQuQnVyZ2VySW5uZXIge1xuXHRcdFx0XHRcdFx0XHRcdCY6YmVmb3JlLFxuXHRcdFx0XHRcdFx0XHRcdCY6YWZ0ZXIge1xuXHRcdFx0XHRcdFx0XHRcdFx0b3BhY2l0eTogMDtcblx0XHRcdFx0XHRcdFx0XHRcdHRyYW5zaXRpb246IGJvdHRvbSAwLjA4cyBlYXNlLW91dCxcblx0XHRcdFx0XHRcdFx0XHRcdFx0XHRcdFx0dG9wIDAuMDhzIGVhc2Utb3V0LFxuXHRcdFx0XHRcdFx0XHRcdFx0XHRcdFx0XHRvcGFjaXR5IDBzIDAuMDhzIGxpbmVhcjtcblx0XHRcdFx0XHRcdFx0XHR9XG5cdFx0XHRcdFx0XHRcdFx0JjpiZWZvcmUge1xuXHRcdFx0XHRcdFx0XHRcdFx0dG9wOiAwO1xuXHRcdFx0XHRcdFx0XHRcdH1cblxuXHRcdFx0XHRcdFx0XHRcdCY6YWZ0ZXIge1xuXHRcdFx0XHRcdFx0XHRcdFx0Ym90dG9tOiAwO1xuXHRcdFx0XHRcdFx0XHRcdH1cblx0XHRcdFx0XHRcdFx0fVxuXHRcdFx0XHRcdFx0fVxuXHRcdFx0XHRcdH1cblx0XHRcdFx0YH08L3N0eWxlPlxuXHRcdFx0PC9CYXNlPlxuXHRcdClcblx0fVxufVxuXG5NaW51cy5kZWZhdWx0UHJvcHMgPSBkZWZhdWx0UHJvcHMiXX0= */\n/*@ sourceURL=../../src/types/minus.js */'
				})
			);
		}
	}]);
	return Minus;
}(_react2.default.Component);

exports.default = Minus;


Minus.defaultProps = _defaultProps2.default;
module.exports = exports['default'];
//# sourceMappingURL=minus.js.map